import { Chip, IconButton, Tooltip } from "@material-ui/core";
import { columnTextField, columnNumberField } from "utils/tables-utils";
import { RequestPageOutlined } from "@mui/icons-material";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { LONGTERM_STATUS } from "../view/titulos-financeiros";
import useLogs from "hooks/logs";

function sortableDateValue(cell) {
  if (cell == null || cell === "") return "";
  const s = String(cell).trim();
  if (s.length === 10 && s.includes("-")) return s.replace(/-/g, "");
  const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (br) return `${br[3]}${br[2]}${br[1]}`;
  return s;
}

export default function TableTitulos({ data, totalRegistros, extraActions }) {
  const { setLocalStorageActions } = useLogs();

  const downloadBoleto = (url) => {
    if (url) {
      window.open(url, "_blank");

      setLocalStorageActions({
        nomeTela: "Lojista 360 - Títulos Financeiros",
        idMenu: "10",
        acao: "Download do Boleto de títulos",
      });
    }
  };

  const columnModel = [
    columnTextField({
      dataField: "Boleto",
      text: "Boleto",
      align: "center",
      formatter: (_, row) => {
        return (
          <>
            {row.BoletoDisponivel && row.UrlBoleto ? (
              <Tooltip title="Visualizar Boleto">
                <IconButton
                  size="small"
                  onClick={() => {
                    downloadBoleto(row.UrlBoleto);
                  }}
                >
                  <RequestPageOutlined fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Boleto não disponível">
                <IconButton size="small">
                  <RequestPageOutlined
                    fontSize="small"
                    color="disabled"
                    style={{ cursor: "not-allowed" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    }),
    columnNumberField({
      dataField: "NumeroTitulo",
      text: "Nr Título",
    }),
    columnTextField({
      dataField: "Situacao",
      text: "Situação",
      align: "center",
      formatter: (_, row) => {
        const status = row.Situacao === "LQ" ? true : false;
        return (
          <Chip
            label={LONGTERM_STATUS.get(row.Situacao)}
            size="small"
            style={{
              width: "100px",
              padding: "1rem 0.5rem",
              backgroundColor: status
                ? "rgba(0, 128, 0, 0.1)"
                : "rgba(255, 215, 0, 0.1)",
              border: status
                ? "1px solid rgba(0, 128, 0, 0.5)"
                : "1px solid rgba(255, 215, 0, 0.5)",
            }}
          />
        );
      },
    }),
    columnTextField({
      dataField: "DataEmissao",
      text: "Emissão",
      align: "center",
      sort: true,
      sortValue: (cell) => sortableDateValue(cell),
    }),
    columnTextField({
      dataField: "DataVencimentoProrrogado",
      text: "Vencimento",
      align: "center",
      sort: true,
      sortValue: (cell) => sortableDateValue(cell),
    }),
    columnTextField({
      dataField: "Valor",
      text: "Valor",
      align: "end",
      formatter: (value) => `R$ ${value}`,
    }),
    columnTextField({
      dataField: "ValorEmAberto",
      text: "Valor em Aberto",
      align: "end",
      formatter: (value) => `R$ ${value}`,
    }),
    columnTextField({
      dataField: "Marca",
      text: "Marca",
      align: "center",
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data}
      columnModel={columnModel}
      keyField="IdTitulo"
      showPrint
      extraActions={extraActions}
      pagination={{
        options: [10, 25, 50, 100],
        defaultOption: 10,
        totalSize: totalRegistros,
        showTotal: true,
      }}
      style={{
        boxShadow: "none",
        margin: "0 -1rem",
      }}
    />
  );
}
